<template>
	<div>
		<div class="row mb-3">
			<div class="col-lg-2">
				<label>Valor *</label>
				<vue-numeric
					class="form-control "
					currency="$"
					separator=","
					placeholder="$0"
					:precision="0"
					v-model="VehiculoRefaccion.Valor"
				></vue-numeric>
			</div>
			<div class="col-lg-7 form-group">
				<label>Proveedores</label>	
				<treeselect
					:disabled="DisabledProveedores"
					:maxHeight="100"
					@input="get_proveedores(proveedoresId)"
					:options="ListaProveedores"
					placeholder="Busque un proveedor..."
					v-model="VehiculoRefaccion.IdProveedor"
					noResultsText="Resultados no encontrados"
					noOptionsText="Opciones no disponibles"
					:disable-fuzzy-matching="true"
				/>
			</div>
			<div class="col-lg-3">
				<label for="">Número Factura o Recibo</label>
				<input type="text" class="form-control" v-model="VehiculoRefaccion.NumFactura">
			</div>
		</div>
		<div class="row mb-3">
			<div class="col-lg-3">
				<label for="">Fecha Factura o Recibo *</label>
                <v-date-picker :masks="{input:'DD-MM-YYYY'}" v-model="VehiculoRefaccion.Fecha" :mode="typeCalendar"
					@input="sumDayPay()"
					:popover="{
						placement: 'bottom',
						visibility: 'click'
					}"
					:input-props="{
						class: 'form-control cal-black',
						style: 'cursor:pointer;'
					}"
                    :locale="'es-MX'"
				/>
			</div>
			<div class="col-lg-2">
				<label> Credito (días) </label>
				<!-- <input
					@input="sumDayPay()"
					class="form-control form-finanza"
					:precision="0"
					v-model="VehiculoRefaccion.DiasCredito"
					placeholder="0"
				/> -->
				<select v-model="VehiculoRefaccion.DiasCredito" class="form-control" @change="sumDayPay">
					<option value="0">Contado</option>
					<option value="15">15 días</option>
					<option value="30">30 días</option>
					<option value="60">60 días</option>
					<option value="90">90 días</option>
				</select>
			</div>
			<div class="col-lg-3">
				<label for="">Fecha pago *</label>
                <v-date-picker :masks="{input:'DD-MM-YYYY'}" v-model="VehiculoRefaccion.FechaPago" :mode="typeCalendar"
					@input="sumDayPay()"
					:popover="{
						placement: 'bottom',
						visibility: 'click'
					}"
					:input-props="{
						class: 'form-control cal-black',
						style: 'cursor:pointer;'
					}"
                    :locale="'es-MX'"
				/>
			</div>
			<div class="col-lg-4">
				<label>Factura</label>
				<div class="custom-file-input-image">
					<input @change="SubirArchivo()" type="file" accept="application/pdf" ref="facturarefaccion" class="custom-file-input" id="validatedCustomFile" required>
					<input type="text" v-model="ArchivoFactura" class="form-control">
					<button type="button" class=""><i class="fas fa-paperclip"></i></button>
				</div>
			</div>
		</div>
		<div class="row mb-3">
			<div class="col-lg-12">
				<label for="">Observaciones</label>
				<textarea class="form-control" v-model="VehiculoRefaccion.Observaciones" cols="10" rows="3"></textarea>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name:"refaccion",
    props:["poBtnSave","pIdVehiculo"],
	data() {
        return {
            Modal:true,
            FormName:'Refaccion',
            EmitSeccion:this.poBtnSave.EmitSeccion,
            VehiculoRefaccion:{
                IdVehiculoRefaccion:0,
                IdVehiculo:0,
                Fecha:'',
				Valor:0,
                Observaciones:'',
				IdProveedor:null,
				NumFactura:'',
				DiasCredito:0,
				FechaPago:'',
				ArchivoFactura:''
            },
			ArchivoFactura:'',
            errorvalidacion:[],
			ListaProveedores: [],
			IndexPaqueteCta:0,
			DisabledProveedores:false
        }
    },
	methods: {
		Guardar(){
            let Fecha='';
			let FechaPago='';
            if (this.VehiculoRefaccion.Fecha!='' && this.VehiculoRefaccion.Fecha!=undefined) {
                let day=this.VehiculoRefaccion.Fecha.getDate();
                let month=this.VehiculoRefaccion.Fecha.getMonth()+1;
                let year=this.VehiculoRefaccion.Fecha.getFullYear();
                Fecha=year+'-'+month+'-'+day;   
            }
			if (this.VehiculoRefaccion.FechaPago!='' && this.VehiculoRefaccion.FechaPago!=undefined) {
                let day=this.VehiculoRefaccion.FechaPago.getDate();
                let month=this.VehiculoRefaccion.FechaPago.getMonth()+1;
                let year=this.VehiculoRefaccion.FechaPago.getFullYear();
                FechaPago=year+'-'+month+'-'+day;   
            }
            let formData=new FormData();
            formData.set('IdVehiculoRefaccion',this.VehiculoRefaccion.IdVehiculoRefaccion);
            formData.set('IdVehiculo',this.VehiculoRefaccion.IdVehiculo);
            formData.set('Valor',this.VehiculoRefaccion.Valor);
			formData.set('NumFactura',this.VehiculoRefaccion.NumFactura);
			formData.set('DiasCredito',this.VehiculoRefaccion.DiasCredito);
			formData.set('IdProveedor',this.VehiculoRefaccion.IdProveedor);
            formData.set('Observaciones',this.VehiculoRefaccion.Observaciones);
			formData.set('ArchivoFactura',this.VehiculoRefaccion.ArchivoFactura);
            formData.set('Fecha',Fecha);
			formData.set('FechaPago',FechaPago);
			let image=this.$refs.facturarefaccion.files[0];
			formData.append('ArchivoFacturaFile',image);
            this.poBtnSave.toast=0;
            this.poBtnSave.disableBtn=true;
            this.$http.post('vehiculorefaccion/post',formData,{
				headers:{
                    'Content-Type':'multipart/form-data'
                }
			}).then((res)=>{
                this.poBtnSave.disableBtn=false; 
                this.poBtnSave.toast=1;
                $("#Refaccion").modal("hide");
				this.bus.$emit('List');
                this.bus.$emit('ListaPrincipal');
            }).catch((err)=>{
                this.errorvalidacion=err.response.data.message.errores;
                this.poBtnSave.disableBtn=false;
                this.poBtnSave.toast=2;
            });
        },
		Limpiar(){
            this.VehiculoRefaccion={
                IdVehiculoRefaccion:0,
                IdVehiculo:0,
                Fecha:new Date(),
				Valor:0,
                Observaciones:'',
				IdProveedor:null,
				NumFactura:'',
				DiasCredito:0,
				FechaPago:new Date(),
				ArchivoFactura:''
            },
			this.ArchivoFactura='Elegir archivo (0.5MB)';
			this.IndexPaqueteCta=0;
			this.DisabledProveedores=false;
        },
		Recuperar(){
            this.$http.get('vehiculorefaccion/recovery',{
                params:{
                    IdVehiculoRefaccion:this.VehiculoRefaccion.IdVehiculoRefaccion
                }
            }).then((res)=>{
                const objres=res.data.data.vehiculorefaccion;
                this.VehiculoRefaccion.IdVehiculoRefaccion=objres.IdVehiculoRefaccion;
                this.VehiculoRefaccion.IdVehiculo=objres.IdVehiculo;
                this.VehiculoRefaccion.Valor=objres.Valor;
                this.VehiculoRefaccion.Observaciones=objres.Observaciones;
				this.VehiculoRefaccion.IdProveedor=objres.IdProveedor == 0 ? null : objres.IdProveedor;
				this.VehiculoRefaccion.DiasCredito=objres.DiasCredito;
				this.VehiculoRefaccion.NumFactura=objres.NumFactura;
				this.VehiculoRefaccion.ArchivoFactura=objres.ArchivoFactura;
				this.VehiculoRefaccion.Observaciones=objres.Observaciones;
                let formatedDate = objres.Fecha.replace(/-/g, "\/");
                this.VehiculoRefaccion.Fecha=new Date(formatedDate);
				let formatedDate2 = objres.FechaPago.replace(/-/g, "\/");
                this.VehiculoRefaccion.FechaPago=new Date(formatedDate2);
				this.ArchivoFactura=objres.ArchivoFactura;

            })
        },
		SubirArchivo(){
			const image = this.$refs.facturarefaccion.files[0];

            var FileSize = image.size / 1024 / 1024; // in MB
            if (FileSize > 0.5) {
                this.$toast.info('Solo se puede subir archivos menores a 0.5 MB');
                const  input  = this.$refs.facturarefaccion;
                input .type = 'text'
                input .type = 'file';
                return false;
            }
                        
            var allowedExtensions = /(\.pdf|\.PDF)$/i;
            if(!allowedExtensions.exec(image.name)){
                this.$toast.info('Extenciones permitidas .pdf');
                const  input  = this.$refs.facturarefaccion;
                input.type = 'text'
                input.type = 'file';
                this.ArchivoFactura='Elegir archivo (0.5MB)';
                return false;
            }

            this.ArchivoFactura=image.name;
		},
		get_proveedores(id) {
			this.$http
				.get("ctaproveedores/get", {
					params: {}
				})
				.then(res => {
					this.ListaProveedores = res.data.data.proveedores.map(function(obj) {
						return { id: obj.IdProveedor, label: obj.Nombre };
					});
				});
		},
		sumDayPay() {
			let days = this.VehiculoRefaccion.DiasCredito;
			let dateParam = this.VehiculoRefaccion.Fecha;

			if (days > 0) {
				var date = new Date(dateParam);
				date.setDate(dateParam.getDate() + parseInt(days)); //sumamos días a la fecha recibida
				this.VehiculoRefaccion.FechaPago = date; //fecha pago = fecha factura + días de crédito
			}
			else{
				this.VehiculoRefaccion.FechaPago=this.VehiculoRefaccion.Fecha;
			}
		},
	},
	created() {
		this.bus.$off("NewModal_"+this.EmitSeccion);
        this.bus.$on("NewModal_"+this.EmitSeccion,(data,Id,IdVehiculo)=>{
            this.poBtnSave.disableBtn=false;
			this.get_proveedores();
            this.bus.$off("Save_"+this.EmitSeccion);
            this.bus.$on("Save_"+this.EmitSeccion, () => {
				this.Guardar();
			});
            this.Limpiar();
            if (IdVehiculo!==undefined) {
                this.VehiculoRefaccion.IdVehiculo=IdVehiculo;
            }
            if (Id > 0) {
				this.VehiculoRefaccion.IdVehiculoRefaccion = Id;
				this.Recuperar();
			}
			
			let User=JSON.parse(sessionStorage.getItem("user"));
			this.IndexPaqueteCta=User.listaPaquetesPrincipal.findIndex((element)=>element.Paquete=='Cuentas por Pagar / Administración' || element.Paquete=='Cuentas por Pagar / Operaciones');
			if (this.IndexPaqueteCta==-1) {
				this.DisabledProveedores=true;
			}
        });
	},
	computed:{
        typeCalendar:function(){
            return 'single';
        }
    }
}
</script>

<style>

</style>
